module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Airline Details")])], 1), _vm._v(" "), _c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Digit Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "digitCode",
      "name": "digitCode"
    },
    model: {
      value: (_vm.airModal.digitCode),
      callback: function($$v) {
        _vm.$set(_vm.airModal, "digitCode", $$v)
      },
      expression: "airModal.digitCode"
    }
  }), _vm._v(" "), (!_vm.airModal.digitCode) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.digitCode))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Airline Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "airlineName",
      "name": "airlineName"
    },
    model: {
      value: (_vm.airModal.airlineName),
      callback: function($$v) {
        _vm.$set(_vm.airModal, "airlineName", $$v)
      },
      expression: "airModal.airlineName"
    }
  })], 1), _vm._v(" "), (!_vm.airModal.airlineName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.airlineName))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("IATA Designator")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "iataDesignator",
      "name": "iataDesignator"
    },
    model: {
      value: (_vm.airModal.iataDesignator),
      callback: function($$v) {
        _vm.$set(_vm.airModal, "iataDesignator", $$v)
      },
      expression: "airModal.iataDesignator"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("ICAO Designator")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "icaoDesignator",
      "name": "icaoDesignator"
    },
    model: {
      value: (_vm.airModal.icaoDesignator),
      callback: function($$v) {
        _vm.$set(_vm.airModal, "icaoDesignator", $$v)
      },
      expression: "airModal.icaoDesignator"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "justify-content-center"
  }, [_c('b-button', {
    staticClass: "smbutnWidth ",
    attrs: {
      "variant": "primary",
      "size": "sm",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addAirLine
    }
  }, [_vm._v(_vm._s((_vm.airModal.airlineId != '') ? 'Update' : "Add"))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [_c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "size": "sm",
      "disabled": _vm.ExcelBtnName != 'Export as Excel' ? true : false,
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getData('Excel')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.ExcelBtnName) + "\n              "), (_vm.ExcelBtnName != 'Export as Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type To Search"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.airLineArray,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "airlineId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "isAirActive",
      fn: function(row1) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.editAir(row1.item)
            }
          }
        }, [_vm._v("Edit")])]
      }
    }, {
      key: "isAirStatusActive",
      fn: function(row2) {
        return [(_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row2.item.airlineId
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row2.item.airlineId,
            "name": "approval",
            "value": row2.item.isAirActive == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateUser(row2.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row2.item.isAirActive == 1 ? "Active" : "In-Active"))])], 1)])], 1) : _c('div', {
          attrs: {
            "id": 'row' + row2.item.airlineId
          }
        }, [_c('h6', [_c('b-badge', [_vm._v(_vm._s(row2.item.isAirActive == 1 ? "Active" : "In-Active"))])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4d2cf38","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/airFreight/airlineMaster.vue
// module id = 2824
// module chunks = 0